/* Keep the pillar navigation native, keyboard accessible, and clear of the store header. */
(() => {
  const root = document.getElementById('made-better');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const links = [...root.querySelectorAll('a[href^="#"]')];
  const sections = links.map(link => root.querySelector(link.getAttribute('href')));
  let scheduled = false;
  function update() {
    scheduled = false;
    let active = 0;
    sections.forEach((section, index) => {
      if (section && section.getBoundingClientRect().top <= 180) active = index;
    });
    links.forEach((link, index) => {
      link.style.backgroundColor = index === active ? link.style.getPropertyValue('--pillar-hover') : '';
      if (index === active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  }
  window.addEventListener('scroll', () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();
